module.exports = __webpack_public_path__ + "img/Capgemini_RGB.faab077a.png";